import defaultSettings from "../../settings";
import type { ActionTree, MutationTree } from "vuex";
const { fixedHeader, sidebarLogo } = defaultSettings;
export interface AppSettingsStateType {
  fixedHeader: boolean;
  sidebarLogo: boolean;
  collapseMenu: boolean;
}

export const state: AppSettingsStateType = {
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  collapseMenu: false,
};
export interface ChangSettingPayInterface {
  key: string;
  value: any;
}
const mutations: MutationTree<AppSettingsStateType> = {
  CHANGE_SETTING: (
    state: AppSettingsStateType,
    data: ChangSettingPayInterface
  ) => {
    type StateKeyType = keyof typeof state;
    if (state[data.key as StateKeyType]) {
      state[data.key as StateKeyType] = data.value;
    }
  },

  CHANGE_COLLAPSE_MENU: (state: AppSettingsStateType) => {
    state.collapseMenu = !state.collapseMenu;
  },
};

const actions: ActionTree<AppSettingsStateType, any> = {
  changeSetting({ commit }, data) {
    commit("CHANGE_SETTING", data);
  },

  changeCollapseMenu({ commit }) {
    commit("CHANGE_COLLAPSE_MENU");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
